<template>
  <div>
    <com-dialog :visible.sync="visible" width="400px" title="赠送套餐卡">
      <div>
        <div class="flex items-center">
          <div class="flex w-100px">用户ID:</div>
          <el-input v-model="form.refUserNumber"></el-input>
        </div>
        <div class="flex items-center justify-end mt-30px">
          <el-button @click="close">取消</el-button>
          <el-button type="primary" @click="confirm">确定</el-button>
        </div>
      </div>
    </com-dialog>
  </div>
</template>

<script>
import { giveMonthCard } from '@/api/package-card'

export default {
  data() {
    return {
      visible: false,
      form: {
        monthCardPlanCode: '',
        refUserNumber: ''
      }
    }
  },

  methods: {
    confirm() {
      giveMonthCard(this.form).then(() => {
        this.$emit('update')
        this.$message.success('操作成功')
        this.close()
      })
    },

    open(opt) {
      this.form.monthCardPlanCode = opt.code
      this.form.refUserNumber = ''
      this.visible = true
    },

    close() {
      this.visible = false
    },
  }
}
</script>

<style lang="scss" scoped></style>
